export default __webpack_public_path__ + "static/media/platforms_supported.4828e20d.png";